import React, { FunctionComponent } from 'react';
import { Action } from 'redux';
import { connect, DispatchProp } from 'react-redux';
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { horizontallyDistributeSelectedItems } from '../../modules/annotations/paperActions';

type Props = DispatchProp<Action>;

const HorizontallyDistribute: FunctionComponent<Props> = ({ dispatch }) => (
  <Tooltip disableInteractive disableFocusListener id="remove-page-tooltip" title="Horizontally Distribute">
    <div>
      <IconButton
        sx={{ borderRadius: 0 }}
        aria-label="Horizontally Distribute"
        onClick={() => horizontallyDistributeSelectedItems(dispatch)}
      >
        <FormatLineSpacingIcon sx={{ transform: 'rotate(-90deg)' }} />
      </IconButton>
    </div>
  </Tooltip>
);

export default connect()(HorizontallyDistribute);
